import React, { useState, useRef } from 'react';
import { iconsPath } from '../../utils/imagePath';

const FeedbackModal = ({ closeModal }) => {
  const [feedback, setFeedback] = useState('');
  const [selectedRating, setSelectedRating] = useState(null);
  const [bugMenuOpen, setBugMenuOpen] = useState('');

  const [selectedBug, setSelectedBug] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [uploadedFileName, setUploadedFileName] = useState(null);
  const fileInputRef = useRef(null);

  const ratings = [
    { emoji: iconsPath?.Emoji1Image, emotion: 'angry' },
    { emoji: iconsPath?.Emoji2Image, emotion: 'sad' },
    { emoji: iconsPath?.Emoji3Image, emotion: 'neutral' },
    { emoji: iconsPath?.Emoji4Image, emotion: 'happy' },
    { emoji: iconsPath?.Emoji5Image, emotion: 'love' },
  ];

  const bugTypes = [
    'UI Issue',
    'Performance Problem',
    'Crash',
    'Feature Not Working',
    'Other',
  ];

  const categories = [
    'User Interface',
    'Performance',
    'Functionality',
    'Documentation',
    'Suggestion',
  ];

  const handleBugSelect = (bug) => {
    setSelectedBug(bug);
    setBugMenuOpen('');
  };

  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
    setBugMenuOpen('');
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setUploadedFileName(file.name);
      // Here you would typically send the file to your server
      // For example: formData.append('screenshot', file);
    }
  };

  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  return (
    <div className="flex  items-center justify-center">
      <div className="bg-[#131418] w-96 rounded-lg p-6 text-white shadow-lg relative">
        {/* Close button */}
        <button
          onClick={closeModal}
          className="absolute top-4 right-4 bg-[#31333A] rounded-full p-2"
        >
          <img className="h-3 w-3" src={iconsPath?.group95Image} alt="" />
        </button>

        {/* Title */}
        <h2 className="text-center font-medium mb-6">
          Please rate your experience
        </h2>

        {/* Rating emojis */}
        <div className="flex justify-between mb-6 mx-8">
          {ratings.map((rating, index) => (
            <button
              key={index}
              className={`rounded-full p-1 ${
                selectedRating === index ? 'ring-2 ring-[#ffffff]' : ''
              }`}
              onClick={() => setSelectedRating(index)}
            >
              <img className="h-8 w-8" src={rating.emoji}></img>
            </button>
          ))}
        </div>

        {/* Report a Bug Dropdown */}
        <div className="relative mb-3">
          <button
            className="flex items-center justify-between w-full bg-[#31333A] rounded-md p-3"
            onClick={() => {
              if (bugMenuOpen === 'bugMenu') {
                setBugMenuOpen('');
              } else {
                setBugMenuOpen('bugMenu');
              }
            }}
          >
            <span className="text-[14px]">{selectedBug || 'Report a Bug'}</span>
            <span className="text-gray-400">
              <img className="h-3 w-3" src={iconsPath?.backarrowImage} alt="" />
            </span>
          </button>

          {bugMenuOpen === 'bugMenu' && (
            <div className="absolute z-10 w-full mt-1 bg-[#31333A] rounded-md shadow-lg">
              {bugTypes.map((bug, index) => (
                <button
                  key={index}
                  className="block w-full text-left px-4 py-2 hover:bg-gray-700"
                  onClick={() => handleBugSelect(bug)}
                >
                  {bug}
                </button>
              ))}
            </div>
          )}
        </div>

        {/* Select a Category Dropdown */}
        <div className="relative mb-3">
          <button
            className="flex items-center justify-between w-full bg-[#31333A] rounded-md p-3"
            onClick={() => {
              if (bugMenuOpen === 'categoryMenu') {
                setBugMenuOpen('');
              } else {
                setBugMenuOpen('categoryMenu');
              }
            }}
          >
            <span className="text-[14px]">
              {selectedCategory || 'Select a Category'}
            </span>
            <span className="text-gray-400">
              <img className="h-3 w-3" src={iconsPath?.backarrowImage} alt="" />
            </span>
          </button>

          {bugMenuOpen === 'categoryMenu' && (
            <div className="absolute z-10 w-full mt-1 bg-[#31333A] rounded-md shadow-lg">
              {categories.map((category, index) => (
                <button
                  key={index}
                  className="block w-full text-left px-4 py-2 hover:bg-gray-700"
                  onClick={() => handleCategorySelect(category)}
                >
                  {category}
                </button>
              ))}
            </div>
          )}
        </div>

        {/* Feedback textarea */}
        <textarea
          className="w-full bg-[#31333A] placeholder:text-[#A4A4A4] text-[14px] outline-none rounded-md p-3 mb-6 resize-none"
          rows="3"
          placeholder="Add your feedback"
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
        />

        {/* Upload Screenshot Section */}
        <div
          className="border-2 border-dashed border-[#8A8C96] rounded-md p-3 mb-6 flex items-center justify-center cursor-pointer"
          onClick={triggerFileInput}
        >
          <input
            type="file"
            ref={fileInputRef}
            className="hidden"
            accept="image/*"
            onChange={handleImageUpload}
          />

          <img className="h-7 w-7 mr-2" src={iconsPath?.group117Image} alt="" />
          <span className="text-gray-500">
            {uploadedFileName
              ? `Uploaded: ${uploadedFileName}`
              : 'Upload Screenshot'}
          </span>
        </div>

        {/* Buttons */}
        <div className="flex space-x-3 justify-start">
          <button className="bg-[#31333A] text-[#A4A4A4] text-[12px] px-8 py-2 rounded-md">
            Submit
          </button>
          <button
            onClick={closeModal}
            className="bg-transparent text-white px-4 py-2 rounded-md"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default FeedbackModal;
